/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrateColor } from './CrateColor';
import {
    CrateColorFromJSON,
    CrateColorFromJSONTyped,
    CrateColorToJSON,
    CrateColorToJSONTyped,
} from './CrateColor';
import type { LootBoxPlacementContext } from './LootBoxPlacementContext';
import {
    LootBoxPlacementContextFromJSON,
    LootBoxPlacementContextFromJSONTyped,
    LootBoxPlacementContextToJSON,
    LootBoxPlacementContextToJSONTyped,
} from './LootBoxPlacementContext';
import type { LootBoxCycleType } from './LootBoxCycleType';
import {
    LootBoxCycleTypeFromJSON,
    LootBoxCycleTypeFromJSONTyped,
    LootBoxCycleTypeToJSON,
    LootBoxCycleTypeToJSONTyped,
} from './LootBoxCycleType';

/**
 * 
 * @export
 * @interface CreateLootBoxConfigBody
 */
export interface CreateLootBoxConfigBody {
    /**
     * 
     * @type {string}
     * @memberof CreateLootBoxConfigBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLootBoxConfigBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLootBoxConfigBody
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLootBoxConfigBody
     */
    redemptionAnimation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLootBoxConfigBody
     */
    transitionEffectEnabled?: boolean;
    /**
     * 
     * @type {LootBoxCycleType}
     * @memberof CreateLootBoxConfigBody
     */
    cycleType?: LootBoxCycleType;
    /**
     * 
     * @type {Date}
     * @memberof CreateLootBoxConfigBody
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateLootBoxConfigBody
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateLootBoxConfigBody
     */
    maxOpensPerUser?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLootBoxConfigBody
     */
    maxOpensPerUserPerCycle?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLootBoxConfigBody
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLootBoxConfigBody
     */
    fuelPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLootBoxConfigBody
     */
    minPurchaseQuantity?: number;
    /**
     * 
     * @type {Array<LootBoxPlacementContext>}
     * @memberof CreateLootBoxConfigBody
     */
    placementContexts?: Array<LootBoxPlacementContext>;
    /**
     * 
     * @type {number}
     * @memberof CreateLootBoxConfigBody
     */
    sortPriority?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLootBoxConfigBody
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLootBoxConfigBody
     */
    onChain?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateLootBoxConfigBody
     */
    nftTracker?: string;
    /**
     * 
     * @type {CrateColor}
     * @memberof CreateLootBoxConfigBody
     */
    crateColor?: CrateColor;
}



/**
 * Check if a given object implements the CreateLootBoxConfigBody interface.
 */
export function instanceOfCreateLootBoxConfigBody(value: object): value is CreateLootBoxConfigBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateLootBoxConfigBodyFromJSON(json: any): CreateLootBoxConfigBody {
    return CreateLootBoxConfigBodyFromJSONTyped(json, false);
}

export function CreateLootBoxConfigBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLootBoxConfigBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'image': json['image'] == null ? undefined : json['image'],
        'redemptionAnimation': json['redemptionAnimation'] == null ? undefined : json['redemptionAnimation'],
        'transitionEffectEnabled': json['transitionEffectEnabled'] == null ? undefined : json['transitionEffectEnabled'],
        'cycleType': json['cycleType'] == null ? undefined : LootBoxCycleTypeFromJSON(json['cycleType']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'maxOpensPerUser': json['maxOpensPerUser'] == null ? undefined : json['maxOpensPerUser'],
        'maxOpensPerUserPerCycle': json['maxOpensPerUserPerCycle'] == null ? undefined : json['maxOpensPerUserPerCycle'],
        'price': json['price'] == null ? undefined : json['price'],
        'fuelPrice': json['fuelPrice'] == null ? undefined : json['fuelPrice'],
        'minPurchaseQuantity': json['minPurchaseQuantity'] == null ? undefined : json['minPurchaseQuantity'],
        'placementContexts': json['placementContexts'] == null ? undefined : ((json['placementContexts'] as Array<any>).map(LootBoxPlacementContextFromJSON)),
        'sortPriority': json['sortPriority'] == null ? undefined : json['sortPriority'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'onChain': json['onChain'] == null ? undefined : json['onChain'],
        'nftTracker': json['nftTracker'] == null ? undefined : json['nftTracker'],
        'crateColor': json['crateColor'] == null ? undefined : CrateColorFromJSON(json['crateColor']),
    };
}

export function CreateLootBoxConfigBodyToJSON(json: any): CreateLootBoxConfigBody {
    return CreateLootBoxConfigBodyToJSONTyped(json, false);
}

export function CreateLootBoxConfigBodyToJSONTyped(value?: CreateLootBoxConfigBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'image': value['image'],
        'redemptionAnimation': value['redemptionAnimation'],
        'transitionEffectEnabled': value['transitionEffectEnabled'],
        'cycleType': LootBoxCycleTypeToJSON(value['cycleType']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'maxOpensPerUser': value['maxOpensPerUser'],
        'maxOpensPerUserPerCycle': value['maxOpensPerUserPerCycle'],
        'price': value['price'],
        'fuelPrice': value['fuelPrice'],
        'minPurchaseQuantity': value['minPurchaseQuantity'],
        'placementContexts': value['placementContexts'] == null ? undefined : ((value['placementContexts'] as Array<any>).map(LootBoxPlacementContextToJSON)),
        'sortPriority': value['sortPriority'],
        'isActive': value['isActive'],
        'onChain': value['onChain'],
        'nftTracker': value['nftTracker'],
        'crateColor': CrateColorToJSON(value['crateColor']),
    };
}

